import cn from 'classnames';
import React, { memo } from 'react';

import styles from './styles.module.scss';

interface IProps {
  className?: string;
  title: string;
  data: string | React.ReactNode;
}

const Feature: React.FC<IProps> = memo(({ className, title, data }) => {
  if (!data) return null;

  return (
    <div className={cn(styles.wrapper, className)}>
      <div className={styles.title}>{title}</div>
      <div className={styles.data}>{data}</div>
    </div>
  );
});

export default Feature;
